import {
  createContext,
  createElement,
  useContext,
  useEffect,
  useMemo,
  type ReactNode,
} from "react";

import { useDashboardRealtime } from "../../hooks/useDashboardRealtime";
import { createOrgChannelsQueryStore } from "./orgChannelsQueryStore";

const disabledStore = createOrgChannelsQueryStore(null);
const OrgChannelsContext = createContext(disabledStore);

export function OrgChannelsProvider({
  children,
  organizationId,
  userId,
  includeDeleted,
}: {
  children?: ReactNode;
  organizationId: string | null;
  userId: string | null;
  includeDeleted: boolean;
}) {
  const store = useMemo(
    () =>
      createOrgChannelsQueryStore(
        organizationId && userId
          ? { includeDeleted, organizationId, userId }
          : null,
      ),
    [organizationId, userId, includeDeleted],
  );
  const { subscribe, status, connectionId } = useDashboardRealtime({
    enabled: organizationId !== null && userId !== null,
  });
  useEffect(() => store.connect(), [store]);
  useEffect(
    () => subscribe(store.onRealtime, { topic: "internalEventTopic" }),
    [subscribe, store],
  );
  useEffect(() => {
    if (status === "open") {
      store.refreshAll();
    }
  }, [connectionId, status, store]);
  return createElement(OrgChannelsContext.Provider, { value: store }, children);
}

export function useOrgChannelsQueryStore() {
  return useContext(OrgChannelsContext);
}
